import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/qrcode.png'
import _imports_1 from '@/assets/wechat.png'


const _withScopeId = n => (_pushScopeId("data-v-789d6968"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "content" }
const _hoisted_2 = { id: "title_content" }
const _hoisted_3 = { id: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "qrCode_content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "qrCode_img",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", { id: "qrCode_des_content" }, [
    /*#__PURE__*/_createElementVNode("img", {
      id: "qrCode_des_icon",
      src: _imports_1
    }),
    /*#__PURE__*/_createElementVNode("div", { id: "qrCode_des" }, "扫码上方二维码关注我们")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(this.$props.item.title), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$props.item.content, (des, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          id: "des"
        }, _toDisplayString(des), 1))
      }), 128))
    ]),
    _hoisted_4
  ]))
}